import React from 'react';
import { Button } from '@/components/ui/button';

import type { ProgramControlCommonProps, SubmitReportFn } from '../controlTypes';

type CovidVaccineProgramControlsProps = ProgramControlCommonProps & {
  covidVaccineProgramOptions: string[];
  onSubmitReport: SubmitReportFn;
};

export const CovidVaccineProgramControls = ({
  values,
  onFilterChange,
  actionRowClass,
  renderStandardActionButtons,
  renderReportActionLabel,
  covidVaccineProgramOptions,
  onSubmitReport,
}: CovidVaccineProgramControlsProps) => (
  <div className="mb-3 flex flex-wrap items-end justify-between gap-4 rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-40)] bg-white px-4 py-3">
    <div className="flex flex-wrap items-center gap-6">
      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Source</div>
        <div className="flex items-center gap-4 text-xs text-[var(--neutral-gray-120)]">
          <label className="flex items-center gap-1.5"><input type="radio" name="covid-vaccine-source" checked={values.covidVaccineSourceFilter === 'all'} onChange={() => onFilterChange('covidVaccineSourceFilter', 'all')} />All</label>
          <label className="flex items-center gap-1.5"><input type="radio" name="covid-vaccine-source" checked={values.covidVaccineSourceFilter === 'staff'} onChange={() => onFilterChange('covidVaccineSourceFilter', 'staff')} />Staff</label>
          <label className="flex items-center gap-1.5"><input type="radio" name="covid-vaccine-source" checked={values.covidVaccineSourceFilter === 'client'} onChange={() => onFilterChange('covidVaccineSourceFilter', 'client')} />Client</label>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Program</div>
        <select
          value={values.covidVaccineProgramFilter}
          onChange={(event) => onFilterChange('covidVaccineProgramFilter', String(event.target.value || 'all'))}
          className="h-8 min-w-[170px] rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-60)] bg-white px-2 text-xs text-[var(--neutral-gray-120)]"
        >
          <option value="all">All</option>
          {covidVaccineProgramOptions.map((program) => (
            <option key={program} value={program}>{program}</option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Dose 1</div>
        <div className="flex items-center gap-4 text-xs text-[var(--neutral-gray-120)]">
          <label className="flex items-center gap-1.5"><input type="radio" name="covid-vaccine-dose-1" checked={values.covidVaccineShot1Filter === 'all'} onChange={() => onFilterChange('covidVaccineShot1Filter', 'all')} />All</label>
          <label className="flex items-center gap-1.5"><input type="radio" name="covid-vaccine-dose-1" checked={values.covidVaccineShot1Filter === 'Yes'} onChange={() => onFilterChange('covidVaccineShot1Filter', 'Yes')} />Yes</label>
          <label className="flex items-center gap-1.5"><input type="radio" name="covid-vaccine-dose-1" checked={values.covidVaccineShot1Filter === 'None'} onChange={() => onFilterChange('covidVaccineShot1Filter', 'None')} />None</label>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Dose 2</div>
        <div className="flex items-center gap-4 text-xs text-[var(--neutral-gray-120)]">
          <label className="flex items-center gap-1.5"><input type="radio" name="covid-vaccine-dose-2" checked={values.covidVaccineShot2Filter === 'all'} onChange={() => onFilterChange('covidVaccineShot2Filter', 'all')} />All</label>
          <label className="flex items-center gap-1.5"><input type="radio" name="covid-vaccine-dose-2" checked={values.covidVaccineShot2Filter === 'Yes'} onChange={() => onFilterChange('covidVaccineShot2Filter', 'Yes')} />Yes</label>
          <label className="flex items-center gap-1.5"><input type="radio" name="covid-vaccine-dose-2" checked={values.covidVaccineShot2Filter === 'None'} onChange={() => onFilterChange('covidVaccineShot2Filter', 'None')} />None</label>
        </div>
      </div>
    </div>

    <div className={actionRowClass}>
      {renderStandardActionButtons()}
      <Button type="button" variant="outline" size="sm" className="h-8" onClick={() => onSubmitReport({ action: 'all-fields-report', download: '1' })}>
        {renderReportActionLabel('+ All Fields Report')}
      </Button>
    </div>
  </div>
);
